/**
 * billing/billingApi.js
 *
 * Portable API helpers for the credit-billing system (bank transfer flow).
 * Pass `apiBase` to point at a different backend in another project.
 */
import { axiosService } from 'shared/helpers/axios';

const DEFAULT_BASE = '/billing';

async function request(method, path, body, apiBase = DEFAULT_BASE) {
  try {
    const res = method === 'get'
      ? await axiosService.get(`${apiBase}${path}`)
      : await axiosService.post(`${apiBase}${path}`, body);
    return { ok: true, data: res.data };
  } catch (err) {
    const error =
      err.response?.data?.error ||
      err.response?.data?.detail ||
      err.message ||
      'Request failed';
    return { ok: false, error, status: err.response?.status };
  }
}

export const getBalance = (apiBase) =>
  request('get', '/balance/', undefined, apiBase);

export const getPackages = (apiBase) =>
  request('get', '/packages/', undefined, apiBase);

export const getTransactions = (apiBase) =>
  request('get', '/transactions/', undefined, apiBase);

export const getPendingPurchases = (apiBase) =>
  request('get', '/pending_purchases/', undefined, apiBase);

/** Creates a pending purchase and returns bank transfer details + reference code. */
export const createTransferRequest = (packageId, apiBase) =>
  request('post', '/create_transfer_request/', { package_id: packageId }, apiBase);

/** User notifies platform that they have made the bank transfer. */
export const notifyTransferSubmitted = (purchaseId, apiBase) =>
  request('post', '/notify_submitted/', { purchase_id: purchaseId }, apiBase);
